import AccountInformationSection from "./AccountInformationSection";
import { compareDates } from '../../atUtils'
import $ from 'jquery'
import {isOlVersion} from "../../constants";
import { ValidationErrors } from "../../panels/user/constants"
import {setEventPreventHidingAllPanels} from '../../panels/utils'

/**
 * Created by filatov on 20.01.2016.
 */
class EditAccountInformationSection extends AccountInformationSection {}

EditAccountInformationSection.prototype.init = function({
    lightBoxEl = null,
    userManagementData = null,
    currentTime = null,
    userId = null,
    accountSettings = null,
    changesCallback = () => {},
    validateCallback = () => {},
    checkUsernameErrorHandler = () => {},
    corporateSchedule = null,
    userGroupsEnabled = false,
    timeZoneGroupsEnabled = false,
    firstTTDate = null,
    firstLeaveRequestDate = null,
    editedUserIsSelf = false,
    handlerIfNoSuchUserAfterAjax = () => {},
    specificVersionDrawerConstructor = () => {},
    disableDuplicateUsernameCheck = false,
    disableEmptyUsernameCheck = false,
    scrollableContainerEl = null,
    showGroupRows = false,
    needValidation = true,
    releaseDateLabelEl = null,
    hireDateLabelEl = null,
    hireAndReleaseDatesEditable = true,
}) {
    AccountInformationSection.prototype.init.call(this, {
        lightBoxEl,
        userManagementData,
        currentTime,
        userId,
        accountSettings,
        changesCallback,
        validateCallback,
        checkUsernameErrorHandler,
        corporateSchedule,
        userGroupsEnabled,
        timeZoneGroupsEnabled,
        firstTTDate,
        firstLeaveRequestDate,
        editedUserIsSelf,
        handlerIfNoSuchUserAfterAjax,
        specificVersionDrawerConstructor,
        disableDuplicateUsernameCheck,
        disableEmptyUsernameCheck,
        scrollableContainerEl,
        showGroupRows,
        needValidation,
        hireDateLabelEl,
        hireAndReleaseDatesEditable,
    })
    this.releaseDateLabelEl = releaseDateLabelEl
    this.initAndShowReleaseDate(accountSettings.releaseDate, userManagementData, hireAndReleaseDatesEditable)
    $(lightBoxEl).addClass("editMode");
    $(lightBoxEl).toggleClass("online", isOlVersion);
    $(lightBoxEl).toggleClass("downloadable", !isOlVersion);
    return this;
};

EditAccountInformationSection.prototype.initAndShowReleaseDate = function(releaseDate, userManagementData, editable = true){
    var self = this;

    this.releaseDatePlaceholderEl = this.getElementBySubId("releaseDatePlaceholder");
    $(this.releaseDatePlaceholderEl).click((e) => setEventPreventHidingAllPanels(e))

    const parsedDate = _.isString(releaseDate) ? Date.parseJSONDate(releaseDate): releaseDate

    this.releaseDateSelector = this.createDateSelector(
        userManagementData,
        "releaseDate",
        this.releaseDatePlaceholderEl,
        releaseDate,
        this.corporateSchedule,
        function(event, date) {
            self.delReleaseDateBtn.style.display = (editable && !!date) ? "inline-block" : "none"
            $(self).trigger('releaseDateChanged', [self.getReleaseDate()])
        },
        editable
    )


    this.delReleaseDateBtn.style.display = (editable && !!releaseDate) ? "inline-block" : "none"
    this.delReleaseDateBtn.onclick = function() {
        self.releaseDateSelector.unsetValue()
        self.releaseDateSelector.fireEvent("change", this)
    }
    //hide read-only release date row in edit user panel if there is no release date
    $(this.getElementBySubId("releaseDate")).toggle(editable || !!releaseDate)

    this._setReleaseDateLabel(parsedDate)

};

EditAccountInformationSection.prototype.getReleaseDate = function()
{
    return this.releaseDateSelector.getValue();
};

EditAccountInformationSection.prototype.setReleaseDate = function(date, editable)
{
    this.delReleaseDateBtn.style.display = (editable && !!date) ? "inline-block" : "none"
    if (date === null) {
        return this.releaseDateSelector.unsetValue();
    }
    const parsedDate = _.isString(date) ? Date.parseJSONDate(date): date
    this._setReleaseDateLabel(parsedDate)
    return this.releaseDateSelector.setValue(parsedDate);
};

EditAccountInformationSection.prototype._setReleaseDateLabel = function(date)
{
    if (!!date)
        this.releaseDateLabelEl.text(this.releaseDateSelector.formatDate(date))
};

EditAccountInformationSection.prototype._checkReleaseIsBeforeHireDate = function () {

    this.errors[ValidationErrors.RELEASE_DATE_IS_BEFORE_HIRE_DATE] = false;

    if (this.getReleaseDate() && compareDates(this.getHireDate(), this.getReleaseDate()) > 0) {
        this.errors[ValidationErrors.RELEASE_DATE_IS_BEFORE_HIRE_DATE] = true;
        return false;
    }

    return true;
};

EditAccountInformationSection.prototype.customValidate = function (oldErrors) {
    $.extend(this.errors, this.specificFieldsDrawerController.validateFields(oldErrors, this.checkEmpty));
    this._checkReleaseIsBeforeHireDate();
};


export default EditAccountInformationSection



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/EditAccountInformationSection.js